<template>
  <div>
    <a-dropdown :trigger="['click']" placement="bottomLeft" v-if="userDetail">
      <div :class="$style.dropdown">
        <img :class="$style.user" :src="userImage" alt />
        <strong>{{ userDetail ? userDetail.name : "" }}</strong>
      </div>
      <a-menu slot="overlay">
        <a-menu-item>
          <div>
            <strong class="mr-1">Role:</strong> {{ userDetail ? userDetail.role : "" }}
          </div>
        </a-menu-item>
        <a-menu-divider/>
        <a-menu-item>
          <div>
            <strong class="mr-1">Email:</strong> {{ userDetail ? userDetail.email : "" }}
          </div>
        </a-menu-item>
        <a-menu-divider/>
        <a-menu-item>
          <a href="javascript: void(0);" @click="logout">
            <i :class="$style.menuIcon" class="icmn-exit"></i> Logout
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <a href="javascript: void(0);" @click="logout" v-else>
      <i :class="$style.menuIcon" class="icmn-exit"></i> Logout
    </a>
  </div>
</template>

<script>
import Vue from 'vue'
import { userAPIs } from '@/services/authConstantsV1'
import { instance, errorService } from '@/services/api'

export default {
  data: function () {
    return {
      userDetail: null,
      userImage: process.env.BASE_URL + 'resources/images/icon-user.png',
    }
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    if (user) {
      this.userDetail = user
    }
  },
  methods: {
    logout() {
      const accessToken = JSON.parse(localStorage.getItem('okta-token-storage'))
      if (accessToken && accessToken.accessToken) {
        this.$emit('displayLoader', true)
        instance.get(userAPIs.logOut)
          .then(response => {
            localStorage.clear()
            this.logoutUser()
          }).catch(error => {
            this.$emit('displayLoader', false)
            errorService(error)
          })
      } else {
        localStorage.clear()
        this.logoutUser()
      }
    },

    async logoutUser() {
      await this.$auth.logout()
      this.$notification.open({
        message: 'Logout User',
        description: 'User logout successfully!',
        icon: <a-icon type="check-circle" style="color: #46be8a" />,
      })
      Vue.prototype.stopSocket()
      this.$emit('displayLoader', false)
      this.$auth.loginRedirect()
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
